"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScatterPlotColorStrategy = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var pointsChart_1 = require("../_chartColoring/pointsChart");
var ScatterPlotColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(ScatterPlotColorStrategy, _super);
    function ScatterPlotColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScatterPlotColorStrategy.prototype.createColorAssignment = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _stackByAttribute, dv) {
        var colorAssignment = this.singleMeasureColorMapping(colorPalette, colorMapping, dv);
        return {
            fullColorAssignment: colorAssignment,
        };
    };
    ScatterPlotColorStrategy.prototype.createPalette = function (colorPalette, colorAssignment, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stackByAttribute) {
        return _super.prototype.createSingleColorPalette.call(this, colorPalette, colorAssignment, stackByAttribute);
    };
    return ScatterPlotColorStrategy;
}(pointsChart_1.PointsChartColorStrategy));
exports.ScatterPlotColorStrategy = ScatterPlotColorStrategy;
//# sourceMappingURL=scatterPlotColoring.js.map